import { render } from "./new_datail.vue?vue&type=template&id=ec464f96&scoped=true"
import script from "./new_datail.vue?vue&type=script&lang=js"
export * from "./new_datail.vue?vue&type=script&lang=js"

import "./new_datail.vue?vue&type=style&index=0&id=ec464f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec464f96"]])

export default __exports__